import { useMutation } from '@tanstack/react-query';
import { getAllCities } from '@/api/city';
import { CityData, GetAllCitiesData } from "@/types";
import { PostParam } from "@/types";

export function useGetAllCities(props?: PostParam) {
    const { onSuccess, onError } = props || {};

    return useMutation<CityData[], Error, GetAllCitiesData>({
        mutationFn: getAllCities,
        onSuccess,
        onError
    });
}
